import React, { useState, useEffect } from 'react'
import './style.css'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { calculateDistance } from '../../constants/base'
import GoogleMapShow from '../GoogelMap/GoogleMap'
import { base } from '../../constants/base'
import { handelResultClean } from '../../redux/slices/SearchFilterSlice'

const SearchResultFilter = () => {

    const allResults = useSelector(state => state?.SearchFilterSlice?.results)
    const [longitude, setLongitude] = useState(null);
    const [latitude, setLatitude] = useState(null);

    const dispatch = useDispatch()

    const getLocation = () => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                }
            );
        }
    };

    useEffect(() => {
        getLocation();
        return () => {
            dispatch(handelResultClean())
        }
    }, []);


    return (
        <div className="search-filter-box">

            {<div className="container">
                <div className="row">
                    {allResults?.length > 0 ? (
                        <>
                            <div className="col-md-12 mt-4 mb-3">
                                <h1 className="home-main-heading">Workers in your area</h1>
                            </div>

                            <div className="col-xl-5 col-lg-5 col-md-6">
                                <div className="result-card-box">
                                    {allResults?.map((item, index) => (
                                        <Link to={`/service/provider/${item.id}`} key={index}>
                                            <div className="services-card-box justify-content-control">
                                                <div className="card-image">
                                                    <img
                                                        src={`${base.imageUrl}${item?.images[0]?.path}`}
                                                        alt={item?.name || "Worker Image"}
                                                    />
                                                </div>

                                                <div className="services-text-box">
                                                    <div className="full-name-box">
                                                        <h1>{item.name}</h1>
                                                    </div>

                                                    <div className="rating-box mb-2 mt-2">
                                                        {item?.services?.map((service, serviceIndex) => (
                                                            <span key={serviceIndex}>{service?.name}</span>
                                                        ))}
                                                    </div>

                                                    {longitude &&
                                                        latitude &&
                                                        item?.address?.latitude &&
                                                        item?.address?.longitude &&
                                                        <p className="card-common-text">
                                                            {calculateDistance(
                                                                latitude,
                                                                longitude,
                                                                item?.address?.latitude,
                                                                item?.address?.longitude
                                                            )} km away
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="no-data-found-box col-xl-5 col-lg-5 col-md-6">
                            <img src="/images/No-data-cuate.png" alt="No Data Found" />
                        </div>
                    )}
                    <div className="col-xl-7 col-lg-7 col-md-6 space-top-box round-image-box">
                        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387194.0622732494!2d-74.30932777004287!3d40.697019286161634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1721905709773!5m2!1sen!2s" width={"100%"} height={460} style={{ border: 0, borderRadius: '20px' }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> */}

                        <GoogleMapShow />
                    </div>
                </div>
            </div>}
        </div >
    )
}

export default SearchResultFilter